var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.open, title: "Connect DAPP", width: "6.5rem" },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c("p", { staticClass: "des" }, [
            _vm._v(
              "Wells of your choose, the benefit ratio distributed to DAPP is:"
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table_box" },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.tableData } },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", label: "No." },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { property: "nickname", label: "Well Name" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      property: "ratio",
                      label: "Benefit ratio",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.ratio) +
                                "%\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "fr total" }, [
                _vm._v("Total: "),
                _c("span", [_vm._v(_vm._s(_vm.totalVal) + "%")]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Verification Code",
                    prop: "code",
                    rules: {
                      required: true,
                      message: "Please input Verification Code",
                      trigger: "blur",
                    },
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        "Please enter the verifcation code provided by DAPP",
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.form.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "code", $$v)
                      },
                      expression: "form.code",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.open = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnloading },
                  on: { click: _vm.handleSubmite },
                },
                [_vm._v(" Confirm ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }